export default __webpack_public_path__ + "static/media/Waterbanner.8a80988e.jpeg";